import { getRailsClient } from "../client";

const levelsApiBase = "/api/internal_api/v1/levels";
const LevelMetadataApiRoute = `${levelsApiBase}?filter[]=courses`;
const QuestsMetadataApiRoute = `${levelsApiBase}?filter[]=quests`;
const LevelByIdRoute = (levelId: number) => `${levelsApiBase}/${levelId}/roles`;
const allLevelsApiRoute = "/api/internal_api/atlas/v1/current_user/levels";

export const getLevels = async () => {
  try {
    const { data } = await getRailsClient({ useToast: true }).get(levelsApiBase);
    return data;
  } catch (error) {
    console.error("Error loading levels:", error);
    throw error;
  }
};

export const getQuests = async () => {
  const response = await getRailsClient({ useToast: true }).get(QuestsMetadataApiRoute);
  if (response.status === 200) {
    return response.data?.quests || [];
  } else {
    throw new Error(`getQuests: Unable to get quests metadata, status code ${response.status}`);
  }
};

// Raw course entry from /levels?filter[]=courses (Rails LevelPresenters::Show),
// narrowed to the fields getLevelMetadata reads
interface RawLevelCourse {
  id: number;
  name: string;
  description: string;
  status: "locked" | "in_progress" | "passed";
  rankName: string;
  role: unknown;
}

export const getLevelMetadata = async () => {
  const response = await getRailsClient({ useToast: true }).get(LevelMetadataApiRoute);

  if (response.status === 200) {
    return response.data.courses.map((level: RawLevelCourse) => ({
      id: level.id,
      name: level.name,
      description: level.description,
      status: level.status,
      rankName: level.rankName,
      role: level.role,
    }));
  } else {
    throw new Error(
      `getLevelMetadata: Unable to get level metadata, status code ${response.status}`
    );
  }
};

export const getLevelById = async (levelId: number) => {
  const response = await getRailsClient({ useToast: true }).get(LevelByIdRoute(levelId));

  if (response.status === 200) {
    return response.data.roles;
  } else {
    throw new Error(`getLevelById: Unable to get level by ID, status code ${response.status}`);
  }
};

export const getAllLevelData = async () => {
  const response = await getRailsClient({ useToast: true }).get(allLevelsApiRoute);

  if (response.status === 200) {
    return response.data;
  } else {
    throw new Error(`getAllLevelData: Unable to get level data, status code ${response.status}`);
  }
};
